export default __webpack_public_path__ + "static/media/contact_bg.944cc98a.png";